interface EnvConfig {
    NODE_ENV: 'development' | 'production' | 'staging' | 'test';
    API_URL: string;
    MOCKS_ENABLED: boolean;
    MOCK_API_DELAY: boolean;
    SENTRY_DSN: string;
    ENVIRONMENT: 'development' | 'production' | 'staging';
    VITE_SENTRY_PROJECT: string;
    VITE_SENTRY_ORG: string;
}

export const ENV: EnvConfig = {
    NODE_ENV: import.meta.env.MODE as 'development' | 'production' | 'staging' | 'test',
    API_URL: import.meta.env.VITE_API_URL,
    MOCKS_ENABLED: import.meta.env.VITE_MOCKS_ENABLED === 'true',
    MOCK_API_DELAY: import.meta.env.VITE_MOCK_API_DELAY === 'true',
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
    VITE_SENTRY_PROJECT: import.meta.env.VITE_SENTRY_PROJECT,
    VITE_SENTRY_ORG: import.meta.env.VITE_SENTRY_ORG,
};

export const FeatureFlag = {
    COMPETENCY_AUTO_TRANSLATE: 'CompetencyAutoTranslate',
    REPORTS: 'Reports',
    COMPENSATION_PLANNING: 'CompensationPlanning',
    CALIBRATION_REPORT: 'CalibrationReport',
    OBJECTIVE_AI_DRAFT: 'ObjectiveAiDraft',
} as const;

export const {
    API_URL,
    MOCKS_ENABLED,
    NODE_ENV,
    MOCK_API_DELAY,
    SENTRY_DSN,
    ENVIRONMENT,
    VITE_SENTRY_PROJECT,
    VITE_SENTRY_ORG,
} = ENV;
